const config = {
    direction: {
        BOTTOMRIGHT: 'Bottomright',
        BOTTOMLEFT: 'Bottomleft',
        TOPRIGHT: 'Topright',
        TOPLEFT: 'Topleft',
        RIGHTALIGN: 'Rightalign',
        LEFTALIGN: 'Leftalign',
    },

    tooltipPlacement: {
        RIGHT: 'Right',
        LEFT: 'Left',
        MIDDLE: 'Middle',
    },

    triggerEventName: {
        CLICK: 'click',
        MOUSEOVER: 'mouseover',
    },
    tooltipType: {
        LINK: 'link',
        BUTTON: 'button',
        DIV: 'div',
    },
};

export default config;
